// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Mq2U","inner":"Form_inner__MWcyu","range":"Form_range__2yKtF","name":"Form_name__3LxIq","actions":"Form_actions__1SyaL"};